// src/registerSW.js
// Call registerSW() in src/index.js after ReactDOM.render()

export function registerSW() {
  if (window.location.protocol === "file:") return;
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(reg => {
        console.log("Auctus SW registered:", reg.scope);
        setInterval(() => reg.update(), 60 * 60 * 1000);
        reg.update().catch(() => {});
      })
      .catch(err => console.warn("Auctus SW registration failed:", err));
  });
}

/** Unregister SW + wipe Cache API (use once if the app feels stuck on an old build). */
export async function resetAppShellCache() {
  if ("serviceWorker" in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map(r => r.unregister()));
  }
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map(k => caches.delete(k)));
  }
}
